import wrapWithProvider from "./src/wrap-with-provider"
import "./src/global.css"
require('prism-themes/themes/prism-darcula.css');
export const wrapRootElement = wrapWithProvider